module.exports = __webpack_public_path__ + "static/media/arteon-shooting-brake.78017fa8.png";